export const baseUrl = "/meal-registration";

export default {
  text: "Meal Registration",
  key: "menu.mealRegistration",
  level: 1,
  items: [
    {
      icon: "mdi-silverware-clean",
      text: "Room Breakfast Registration",
      level: 2,
      link: baseUrl + "/room-breakfast",
    },
    {
      icon: "mdi-food",
      text: "Room Lunch Registration",
      level: 2,
      link: baseUrl + "/room-lunch",
    },
    {
      icon: "mdi-food-turkey",
      text: "Room Dinner Registration",
      level: 2,
      link: baseUrl + "/room-dinner",
    },
    {
      icon: "mdi-food",
      text: "Banquet Lunch Registration",
      level: 2,
      link: baseUrl + "/banquet-lunch",
    },
    {
      icon: "mdi-food-turkey",
      text: "Banquet Dinner Registration",
      level: 2,
      link: baseUrl + "/banquet-dinner",
    },
  ]
};
